import { useQuery } from '@tanstack/react-query'

export interface DashboardInsights {
  pending: { requests: number; waitlisted: number }
  overdue: { count: number; amountIdr: number }
  lateCheckouts: Array<{
    id: string
    code: string
    customerName: string | null
    boatName: string | null
    berthCode: string | null
    expectedCheckOutAt: string
    minutesLate: number
  }>
  today: { arrivals: number; departures: number }
  revenue: { thisMonthIdr: number; lastMonthIdr: number; momPct: number | null }
  expiringContracts: Array<{
    id: string
    code: string
    customerName: string | null
    endDate: string
    daysUntilExpiry: number
  }>
  occupancy: { free: number; total: number; occupancyPct: number }
  generatedAt: string
}

async function fetchJson<T>(path: string): Promise<T> {
  const res = await fetch(path, { credentials: 'include' })
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}

export function useDashboardInsights() {
  return useQuery({
    queryKey: ['dashboard-insights'],
    queryFn: () => fetchJson<DashboardInsights>('/api/dashboard/insights'),
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
}
